var est_nouvel_onglet = false;
var acces_public = false;

$(document).ready(function () {
    if($('#est_nouvel_onglet').length) {
        est_nouvel_onglet = $('#est_nouvel_onglet').val();
    }

    init_accueil();
    window.history.replaceState({}, document.title, "/" + "");
});

// #15340 : chargement automatique d'un autre module
function intranet_init_module_startup() {
    // combinaison de plusieurs codes legacy pour gérer le chargement dun module automatique
    let startupmodule = $("#idStartupModule");

    // si autoload est false, on ne charge pas automatiquement.
    if (startupmodule.data('autoload') === false) return;

    var idModuleStartup = startupmodule.val();
    startupmodule.val('');
    let elem_lien_module = $("#sidebar").find("li>a[id_module='" + idModuleStartup + "']");

    if (elem_lien_module.length > 0) {
        if(!est_nouvel_onglet) {
            elem_lien_module.click();
        }
    }
}

function init_accueil() {
    $('#btn_profil').off('click').on('click', page_profil);
    $('#btn_gestion_notification').off('click').on('click', pageGestionNotification);

    $('#btn_livrables_s').off('click').on('click', function () {
        $('#nav-list [nom_module="livrables"]').click();
    });

    $('#btn_fiche_role_s').off('click').on('click', function () {
        $('#nav-list [nom_module="fiche_role"]').click();
    });


    //CLIC SUR UN DES MODULES DANS LE MENU DE GAUCHE
    var obj = $('#nav-list').find('li');
    var usager_public = '';

    // si pas de menu de gauche, version public sig-web 2 et role évaluation
    if (obj.length !== 0) {
        // click sur un module
        obj.off('click').on('click', function (e) {
            if ($(e.currentTarget.children[0]).attr('nom_module') === "confection_de_roles") {
                return;
            }

            // Faire sortir de la fonction pour quitter la fonction si le module est confection de rôles pour faire marcher le href
            cleanup_changement_module();
            // On vérifie si l'on se trouve dans un sous-module afin de conserver actif et ouvert l'élément parent dans le menu de gauche
            var li = $(this);
            var ul = li.parent();
            var estUnSousModule = ul.hasClass('submenu');

            obj.removeClass('active');
            if (estUnSousModule) {
                ul.parent().addClass('active');
            }

            li.addClass('active');

            var liParent = null;
            if (estUnSousModule) {
                liParent = ul.closest('li');
                liParent.addClass('active');
            }

            var a = li.find('a');
            var currentIdModule = a.attr('id_module');
            var currentNomModule = a.attr('nom_module') || 'accueil';
            // conserve le dernier lien de navigation...
            window.evb_last_module = a;

            usager_public = $('#usager_public').val();
            var params = {'id_module': currentIdModule, 'usager_public': usager_public};


            switch (currentNomModule) {
                case 'mapviewer':

                    var idMap = $('#idMap').val();
                    if (idMap == "") idMap = -1;

                    wait.start();

                    //CHARGEMENT DU CONTENU DU MODULE DANS LA PAGE
                    $('#page_content').load('/mapviewer/?', $.param({'idMap': idMap}), function () {
                        initMapViewer(idMap);
                        wait.stop();
                    });

                    break;
                case 'bloc_terrain': //DANS LE CAS DU BLOC TERRAIN ON OUVRE LA FICHE DU RÔLE CAR ON RÉUTILISE LE MÊME CODE
                    currentNomModule = 'fiche_role';
                default:
                    wait.start();

                    //CHARGEMENT DU CONTENU DU MODULE DANS LA PAGE
                    var urlModule = currentNomModule;
                    var initCurrentNomModule = currentNomModule.replace(/-/g, "_");

                    if (currentNomModule == 'georole_web_2') {
                        params.id_municipalite = $("#idMunicipaliteStartup").val();
                    }

                    if ($('[name=date_courante]').length > 0) {
                        params.date_courante = $('[name=date_courante]').val();
                    }

                    if (li.find('.submenu-text').length > 0 && !estUnSousModule) { // On est dans le contexte d'un module qui contient plus d'un sous-module. Dans ce cas, on repointe automatiquement sur le sous-module.
                        var liMenuParent = li;
                        liParent = $(this);
                        li = $(this).find('ul.submenu li').first();
                        currentIdModule = li.find('a.submenu-text').first().attr('id_module');
                        params.id_module = currentIdModule;
                        currentNomModule = li.find('a.submenu-text').first().attr('nom_module');
                        urlModule = currentNomModule;
                        initCurrentNomModule = currentNomModule.replace(/-/g, "_");
                        estUnSousModule = true;
                        li.addClass('active');
                        urlModule = liMenuParent.children('a').attr('nom_module') + '/' + currentNomModule;
                    } else if (estUnSousModule) { // Si on charge un sous-module, on doit conserver le chemin du module
                        urlModule = ul.parent().children('a').attr('nom_module') + '/' + currentNomModule;
                    }
                    destroyDataTables();
                    $('#page_content').load('/' + urlModule + '/?', $.param(params), function () {
                        wait.stop();
                        //INITIALISATION DU MODULE AVEC CALL DE FUNCTION DYNAMIQUE (SEULEMENT SI LA FONCTION INIT DU MODULE EST IMPLÉMENTÉE)
                        if (typeof window['init_' + initCurrentNomModule] === "function") window['init_' + initCurrentNomModule](currentIdModule);
                    });
            }
            return false; // Utilisé pourObject.keys(params) supprimer le double chargement de la fonction lorsqu'on sélectionne un sous-module
        });

        intranet_init_module_startup();

    } else {
        let idModuleStartup = Number($('#idStartupModule').val());
        if (idModuleStartup == 22 || idModuleStartup == 61 || idModuleStartup == 72) {
            var params = {
                usager_public: $('#usager_public').val(),
                id_municipalite: $('#idMunicipaliteStartup').val() || $('#id_municipalite_init').val(),
                id_module: idModuleStartup,
                bool_grand_public: true
            };
            $('#page_content').load(`/georole_web_2/?`, $.param(params), function () {
                wait.stop();
            });
        }
    }

    $(".derniere-nouvelle").click(function () {
        $('#contenu-form-activite').html("");
        var idDerniereNouvelle = jQuery(this).attr("id-derniere-nouvelle");

        var params = {
            'id_derniere_nouvelle': idDerniereNouvelle
        };

        $.ajax({
            type: "GET",
            url: "/core/derniere-nouvelle/",
            data: params,
            dataType: 'html',
            success: function (response) {
                $('#contenu-form-activite').html(response);
            }
        });

        $('#modal-form-activite').on('shown.bs.modal', function () {
            setModalMaxHeight(this);
        });

    });

    $(".lien-rapide-feuille-temps").on('click', function () {
        $('#nav-list').find('a[id_module="34"]').trigger('click');
    });
}


function setModalMaxHeight(element) {
    this.$element = $(element);
    this.$content = this.$element.find('.modal-content');
    var borderWidth = this.$content.outerHeight() - this.$content.innerHeight();
    var dialogMargin = $(window).width() > 767 ? 60 : 20;
    var contentHeight = $(window).height() - (dialogMargin + borderWidth);
    var headerHeight = this.$element.find('.modal-header').outerHeight() || 0;
    var footerHeight = this.$element.find('.modal-footer').outerHeight() || 0;
    var maxHeight = contentHeight - (headerHeight + footerHeight);

    this.$content.css({
        'overflow': 'hidden'
    });

    this.$element
        .find('.modal-body').css({
        'max-height': maxHeight,
        'overflow-y': 'auto'
    });
}

function loadPage(obj, params, callback) {

    var parent = obj.parent();
    var estUnSousModule = parent.hasClass('submenu');

    obj.removeClass('active');
    if (estUnSousModule) parent.parent().addClass('active');
    obj.addClass('active');

    var a = obj.find('a');
    var currentIdModule = a.attr('id_module');
    var currentNomModule = a.attr('nom_module') || 'accueil';

    $('.dataTables_scrollBody').scroll(function () {
        var scroll = $('.dataTables_scrollBody').scrollLeft();
        $('.dataTables_scrollHead').scrollLeft(scroll);
    });

    switch (currentNomModule) {
        case 'mapviewer':

            var idMap = $('#idMap').val();
            if (idMap == "") idMap = -1;

            wait.start();

            //CHARGEMENT DU CONTENU DU MODULE DANS LA PAGE
            $('#page_content').load('/mapviewer/?', $.param({'idMap': idMap}), function () {

                initMapViewer(idMap);
                wait.stop();

            });

            break;
        case 'bloc_terrain': //DANS LE CAS DU BLOC TERRAIN ON OUVRE LA FICHE DU RÔLE CAR ON RÉUTILISE LE MÊME CODE
            currentNomModule = 'fiche_role';
            break;

        default:
            wait.start();
            var urlModule = currentNomModule;
            var initCurrentNomModule = currentNomModule.replace(/-/g, "_");

            //Si on charge un sous-module, on doit conserver le chemin du module
            if (estUnSousModule) urlModule = parent.parent().children('a').attr('nom_module') + '/' + currentNomModule;

            params.id_module = currentIdModule;
            destroyDataTables()
            destroy_select2()

            $('#page_content').load('/' + urlModule + '/?', $.param(params), function () {
                wait.stop();
                //INITIALISATION DU MODULE AVEC CALL DE FUNCTION DYNAMIQUE (SEULEMENT SI LA FONCTION INIT DU MODULE EST IMPLÉMENTÉE)
                if (typeof window['init_' + initCurrentNomModule] === "function") window['init_' + initCurrentNomModule](currentIdModule);
                if (typeof (callback) != 'undefined') {
                    callback();
                }
            });
    }
}

function cleanup_changement_module() {
    // Roule les fonctions de cleanup lors d'un changement de module
    if (typeof (window.fonctions_cleanup_changement_module) != 'undefined') {
        for (var i = 0; i < window.fonctions_cleanup_changement_module.length; i++) {
            window.fonctions_cleanup_changement_module[i]();
        }
        window.fonctions_cleanup_changement_module = [];
    }
}
function page_profil() {
    wait.start();
    $.ajax({
        type: "POST",
        url: "/core/profil/",
        dataType: 'html',
        success: function (response) {
            $('body').append(response);
            $('#form_modal_page_profil').modal({
                show: true,
                backdrop: 'static'
            });
            $('#btn_page_profil_change_password').off('click').on('click', function(){
                window.open('/core/password_change/','_blank');
            });
            wait.stop();
        }
    });
}

function destroy_select2(container, reset_value) {
    if (typeof container === "undefined") {
        container = 'body'
    }
    if (reset_value === true) {
        $(container).find('select.select2').select2('val', '');
    }
    $(container).find('select.select2').select2('destroy')
}
